module.exports = __webpack_public_path__ + "static/media/hai.ca37a09c.jpg";